import { store } from './index';
import { logout, loginSuccess } from './slices/authSlice';
import { injectStore } from '@/services/api/axiosInstance';

// Initialize axios with store reference
export const setupStore = () => {
  injectStore(store, { logout, loginSuccess });
};